<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'carriers-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Carriers</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button
                        class="ms-sm-2"
                        text="New"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        [visible]="canManage"
                        (onClick)="addCarrier()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>
            <dxi-column [dataField]="gridFieldName('name')" caption="Name" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('address')" caption="Address" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('scac')" caption="SCAC" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('phone')" caption="Phone #" [minWidth]="100" cellTemplate="phone"></dxi-column>
            <dxi-column [dataField]="gridFieldName('email')" caption="Email" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" [lookup]="{ dataSource: carrierStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                caption="Status" [filterOperations]="['=']" [headerFilter]="{ dataSource: carrierStatusOptions }" [minWidth]="150" cellTemplate="status"
            ></dxi-column>
            <dxi-column dataField="lastModifiedBy.name" caption="Last Modified By" cellTemplate="lastModifiedBy"
                [visible]="false" [minWidth]="250" [calculateFilterExpression]="lastModifiedByFilter"></dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" caption="Last Modified" [minWidth]="150" cellTemplate="lastModified" [visible]="false"></dxi-column>
            <dxi-column dataField="createdBy.name" caption="Created By" cellTemplate="createdBy"
                [visible]="false" [minWidth]="250" [calculateFilterExpression]="createdByFilter"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Created" cellTemplate="created" [minWidth]="150" [visible]="false" [sortOrder]="'desc'"></dxi-column>

            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit" [visible]="canManage"></dxi-button>
                <dxi-button text="view" icon="eyeopen" hint="view" [onClick]="onEdit" [visible]="!canManage"></dxi-button>
                <dxi-button text="delete" icon="trash" hint="delete" [onClick]="onDelete" [visible]="canManage"></dxi-button>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    {{ getCellData(cellInfo).number }}
                </div>
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'phone'">
                {{ getCellData(cellInfo).phone | phoneFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'created'">
                {{ getCellData(cellInfo).created | date:dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'lastModified'">
                {{ getCellData(cellInfo).lastModified | date:dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'lastModifiedBy'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).lastModifiedBy.email"
                    [name]="getCellData(cellInfo).lastModifiedBy.name"
                    [avatarUrl]="getCellData(cellInfo).lastModifiedBy.avatarUrl"
                    [employeeId]="getCellData(cellInfo).lastModifiedBy.id"
                ></user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'createdBy'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).createdBy.email"
                    [name]="getCellData(cellInfo).createdBy.name"
                    [avatarUrl]="getCellData(cellInfo).createdBy.avatarUrl"
                    [employeeId]="getCellData(cellInfo).createdBy.id"
                ></user-avatar-email>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('number')"
                      editorType="dxTextBox"
                      caption="ID"
                      [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}"></dxi-item>
            <dxi-item
                [dataField]="filterModelName('name')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('address')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Address', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('scac')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'SCAC', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('phone')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Phone', stylingMode: 'filled', mask: '(000) 000-0000' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('email')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Email', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: carrierStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="'lastModifiedBy.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Last Modified By', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('lastModified')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Last Modified', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="'createdBy.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Created By', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('created')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <add-carrier-form [(visible)]="isAddCarrierPopupOpened" (onSave)="onSave()"></add-carrier-form>
    <edit-carrier-form [(visible)]="isEditCarrierPopupOpened" [isReadOnly]="!canManage" [carrierId]="carrierId" (onSave)="onSave()"></edit-carrier-form>
</div>
